import { render, staticRenderFns } from "./scenarioCard.vue?vue&type=template&id=0b2285d8&scoped=true&"
import script from "./scenarioCard.vue?vue&type=script&lang=js&"
export * from "./scenarioCard.vue?vue&type=script&lang=js&"
import style0 from "./scenarioCard.vue?vue&type=style&index=0&id=0b2285d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2285d8",
  null
  
)

export default component.exports